import { render, staticRenderFns } from "./BuildingsTerminal.vue?vue&type=template&id=29fb20bc&scoped=true"
import script from "./BuildingsTerminal.vue?vue&type=script&lang=js"
export * from "./BuildingsTerminal.vue?vue&type=script&lang=js"
import style0 from "./BuildingsTerminal.vue?vue&type=style&index=0&id=29fb20bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb20bc",
  null
  
)

export default component.exports